import type { ProgramPublicProfile } from '@/mocks/programProfile';

interface Props {
  profile: ProgramPublicProfile;
}

export default function ProgramScheduleSection({ profile }: Props) {
  return (
    <section className="bg-background-50 rounded-2xl border border-background-200/70 p-5 md:p-6">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center">
          <i className="ri-calendar-schedule-line text-secondary-600 text-sm"></i>
        </div>
        <h2 className="text-base font-bold text-foreground-950">Horarios</h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="flex items-start gap-3 bg-background-100/70 rounded-xl p-4">
          <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center shrink-0">
            <i className="ri-time-line text-primary-600"></i>
          </div>
          <div>
            <p className="text-[10px] text-foreground-400 uppercase font-bold tracking-wider mb-0.5">Horario</p>
            <p className="text-sm font-semibold text-foreground-900">{profile.schedule}</p>
          </div>
        </div>
        <div className="flex items-start gap-3 bg-background-100/70 rounded-xl p-4">
          <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center shrink-0">
            <i className="ri-global-line text-accent-600"></i>
          </div>
          <div>
            <p className="text-[10px] text-foreground-400 uppercase font-bold tracking-wider mb-0.5">Zona horaria</p>
            <p className="text-sm font-semibold text-foreground-900">{profile.timezone}</p>
          </div>
        </div>
        <div className="flex items-start gap-3 bg-background-100/70 rounded-xl p-4">
          <div className="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center shrink-0">
            <i className="ri-radio-line text-emerald-600"></i>
          </div>
          <div>
            <p className="text-[10px] text-foreground-400 uppercase font-bold tracking-wider mb-0.5">Emisora</p>
            <p className="text-sm font-semibold text-foreground-900">{profile.radioName}</p>
            <p className="text-xs text-foreground-400">{profile.radioFrequency}</p>
          </div>
        </div>
      </div>

      {/* Status */}
      <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-200/70">
        <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold ${
          profile.isActive ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'
        }`}>
          <span className={`w-1.5 h-1.5 rounded-full ${profile.isActive ? 'bg-emerald-500 animate-pulse' : 'bg-red-500'}`}></span>
          {profile.isActive ? 'Activo' : 'Pausado'}
        </span>
        <span className="text-xs text-foreground-400">
          {profile.isActive ? 'El programa está actualmente al aire según su horario' : 'El programa no está emitiendo en este momento'}
        </span>
      </div>
    </section>
  );
}